import { useContext } from 'react';
import { WebSocketContext } from '@/contexts/WebSocketContext';
import type { WebSocketContextValue } from '@/contexts/WebSocketContext';

/**
 * WebSocketContext 편의 훅.
 * <WebSocketProvider> 내부에서만 사용 가능.
 *
 * 반환값:
 * - `isConnected` - WebSocket 연결 상태 여부
 * - `subscribe(topic, handler)` - 토픽 구독, 구독 해제 함수 반환
 * - `send(destination, body)` - 백엔드로 메시지 전송
 */
export function useWebSocket(): WebSocketContextValue {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
}
